<template>
  <div class="JPremit">
    <HeaderTop ref="shopcar"></HeaderTop>
    <div class="main">
      <div class="main-top">
        <!-- 左边图片logo -->
        <div class="main-left">
          <img src="@/assets/images/home/JPlogo.png" alt="" />
          <p>极配汇</p>
        </div>
        <!-- 右边三种查询条件 -->
        <div class="main-right">
          <!--选中文字  -->
          <div class="m-w1">
            <span :class="check == 1 ? 'checks' : ''" @click="chicoe(1)"
              >配件查询</span
            >
            <i> &nbsp;&nbsp;|&nbsp;&nbsp; </i>
            <span :class="check == 2 ? 'checks' : ''" @click="chicoe(2)"
              >车型查询
            </span>
            <i> &nbsp;&nbsp;|&nbsp;&nbsp; </i>
            <span :class="check == 3 ? 'checks' : ''" @click="chicoe(3)"
              >VIN码查询</span
            >
          </div>
          <!-- 输入框-->
          <div class="m-w2">
            <div v-show="check == 1">
              <Input
                v-model="obj.partKey"
                placeholder="请输入配件编码/配件名称"
                style="width: 440px"
                @keyup.enter.native="Search(1)"
              />
              <Button type="primary" @click="Search(1)"
                ><i class="iconfont icon-sousuo"></i>搜索</Button
              >
            </div>
            <div v-show="check == 2" class="m-w3">
              <Button type="primary" @click="Search(2)">车型选择</Button>
              <div class="m-w31">
                <div class="m-w33" v-show="searchList.carType">
                  <span
                    >{{ searchList.brandName }}{{ searchList.carName
                    }}{{ searchList.carType }} </span
                  ><Icon
                    type="md-close-circle"
                    size="18"
                    color="#377cf1"
                    @click="delcarType"
                  />
                </div>
                <span v-show="!searchList.carType" class="m-w32"
                  >请选择车型</span
                >
              </div>
            </div>
            <div v-show="check == 3">
              <Input
                v-model.trim="obj.VinKey"
                placeholder="请输入17位车架号"
                style="width: 440px"
                @keyup.enter.native="Search(3)"
              />
              <Button type="primary" @click="Search(3)"
                ><i class="iconfont icon-sousuo"></i>搜索</Button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="main-key">
        <p v-show="checkli == 1">配件查询 >{{ searchList.partKey }}</p>
        <p v-show="checkli == 2">
          车型查询 >{{ searchList.brandName }}{{ searchList.carName
          }}{{ searchList.carType }}
        </p>
        <p v-show="checkli == 3">VIN码查询 >{{ searchList.VinKey }}</p>
      </div>
      <div class="main-com">
        <div class="JPremitL">
          <div class="main">
            <div class="w1">
              <div v-for="(item, index) in tree" :key="item.id" class="w11">
                <!-- <div v-show="item.children.length"> -->
                <!-- {{ item.label }} -->
                <p class="w111" @click="clickOne(item, index)">
                  <span>{{ item.label }}</span>
                  <i
                    class="ivu-icon ivu-icon-ios-arrow-down"
                    :class="item.isShow ? 'oneshow' : 'oneshows'"
                  ></i>
                  <!-- <Icon
                    type="md-add"
                    color="#FFFFFF"
                    :class="item.isShow ? 'oneshow' : 'oneshows'"
                  /> -->
                  <!-- ({{ item.num || 0 }}) -->
                </p>
                <div
                  class="w223"
                  :class="item.isShow ? 'show' : ''"
                  v-for="(i, index) in item.children"
                  :key="i.id"
                >
                  <!-- <div class="w12"> -->
                  <p class="w12" @click="clickTwo(i, index)">
                    <!-- <Icon
                      type="md-add"
                      color="#FFFFFF"
                      :class="i.isShow ? 'oneshow' : 'oneshows'"
                    />&nbsp; -->
                    <span>
                      {{ i.label }}
                    </span>
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      :class="i.isShow ? 'oneshow' : 'oneshows'"
                    ></i>
                    <!-- ({{ i.num || 0 }}) -->
                  </p>
                  <!-- {{ item.label }} &nbsp;| &nbsp;{{ i.label }} -->
                  <!-- </div> -->
                  <div class="w333" :class="i.isShow ? 'show' : ''">
                    <div class="w13">
                      <span
                        v-for="v in i.partNameList"
                        :key="v"
                        @click="checkeds(v)"
                        :class="{ ischeck: arr.indexOf(v) != -1 }"
                        >{{ v }}</span
                      >
                    </div>
                  </div>
                </div>
                <!-- </div> -->
                <!-- <div v-else class="w12">
            {{ item.label }}
          </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="JPremitR">
          <div class="main">
            <!-- 车型结果 -->
            <div class="main-w1" v-show="jpremitShpw">
              <div class="main-car">
                <ul>
                  <li>
                    <p>车辆品牌</p>
                    <p>{{ this.carResult.brand || '暂无' }}</p>
                  </li>
                  <li>
                    <p>车系</p>
                    <p>{{ this.carResult.series || '暂无' }}</p>
                  </li>
                  <li>
                    <p>车型</p>
                    <p>{{ this.carResult.model || '暂无' }}</p>
                  </li>
                  <li>
                    <p>年款</p>
                    <p>{{ this.carResult.model_year || '暂无' }}</p>
                  </li>
                  <li>
                    <p>排量</p>
                    <p>{{ this.carResult.cc || '暂无' }}</p>
                  </li>
                  <li>
                    <p>变速箱</p>
                    <p>{{ this.carResult.trans_code || '暂无' }}</p>
                  </li>
                  <li>
                    <p>发动机</p>
                    <p>{{ this.carResult.engine_no || '暂无' }}</p>
                  </li>
                </ul>
              </div>
              <div class="mian-input">
                <Input
                  v-model="SEvalue"
                  placeholder="请输入OE号/配件名称"
                  style="width: 896px"
                />
                <Button type="primary" @click="searchBtn">查询</Button>
              </div>
            </div>
            <!-- 配件类型 -->
            <div class="main-w2">
              <div class="navigation-grops">
                <p>配件类型</p>
                <ul>
                  <li
                    v-for="item in parTypeList"
                    :key="item.id"
                    :class="partCheck === item.id ? 'checked' : ''"
                    @click="partCheckd(item)"
                  >
                    <span>{{ item.name }}</span>
                  </li>
                </ul>
              </div>
              <div class="navigation-grops">
                <p style="border-bottom: 0">品牌</p>
                <ul style="border-bottom: 0">
                  <li
                    v-for="item in brandList"
                    :class="brandCheck === item ? 'checked' : ''"
                    @click="brandCheckd(item)"
                  >
                    <span>{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 分页 -->
            <div
              style="display: flex; justify-content: right; margin-top: 10px"
            >
              <Page
                :total="pager.total"
                :current="pager.current"
                :page-size="pager.size"
                size="small"
                :page-size-opts="[30]"
                show-total
                @on-change="changeCurrent"
                @on-page-size-change="changeSize"
              />
              <span
                style="
                  line-height: 11px;
                  height: 26px;
                  padding: 7px 10px;
                  border: 1px solid #dcdee2;
                  border-radius: 3px;
                "
                >30条/页</span
              >
            </div>
            <!-- 综合排序 -->
            <div class="active">
              <div class="left">
                <ul>
                  <li
                    @click="synthesisChecked"
                    :class="checkNum == 0 ? 'checked' : ''"
                  >
                    综合排序
                  </li>
                  <li
                    @click="inventoryChecked"
                    :class="checkNum == 1 ? 'checked' : ''"
                  >
                    <span>库存</span>
                    <div class="rotate">
                      <span
                        class="iconfont icon-zuojiantou"
                        :class="searchData.stockSort == 2 ? 'checkedLi' : ''"
                      ></span
                      ><span
                        class="iconfont icon-youjiantou"
                        :class="searchData.stockSort == 1 ? 'checkedLi' : ''"
                      ></span>
                    </div>
                  </li>
                  <li
                    @click="priceChecked"
                    :class="checkNum == 2 ? 'checked' : ''"
                  >
                    <span>价格</span>
                    <div class="rotate">
                      <span
                        class="iconfont icon-zuojiantou"
                        :class="searchData.priceSort == 2 ? 'checkedLi' : ''"
                      ></span
                      ><span
                        class="iconfont icon-youjiantou"
                        :class="searchData.priceSort == 1 ? 'checkedLi' : ''"
                      ></span>
                    </div>
                  </li>
                  <li>
                    <span>发货地：</span>
                    <Select v-model="addressId" style="width: 140px" filterable>
                      <Option
                        v-for="item in cityList"
                        :value="item.id"
                        :key="item.id"
                        @click.native="chioce(item)"
                        >{{ item.name }}</Option
                      >
                    </Select>
                  </li>
                </ul>
              </div>
              <div class="right">
                <Checkbox
                  v-model="hasGoods"
                  @on-change="hasGoodsChange(hasGoods)"
                  >只显示有货</Checkbox
                >
              </div>
            </div>
            <!-- 表头 -->
            <Row class="tableHeader" v-if="dataList.length">
              <!-- <Col span="1"></Col> -->
              <Col span="3">商品图片</Col>
              <Col span="6">商品信息</Col>
              <!-- <Col span="3">店铺</Col> -->
              <Col span="3">发货地</Col>
              <Col span="2">库存</Col>
              <Col span="3">价格</Col>
              <Col span="4">购买数量</Col>
              <Col span="3">操作</Col>
            </Row>
            <!-- 内容 -->
            <div class="table">
              <transition-group
                name="more"
                v-bind:css="false"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-if="dataList.length"
              >
                <div
                  class="tableCenter"
                  v-for="(item, index) in dataList"
                  :key="item.partId"
                >
                  <Row>
                    <Col span="1"></Col>
                    <!-- <div class="mb10">
                <div class="lm">{{ item.owner }}</div>
                <div v-show="item.source">
                  {{ item.source }}
                </div>
              </div> -->
                  </Row>
                  <Row>
                    <!-- <Col span="1">
                <div class="activeBox" v-if="item.type == 1">
                  <span class="iconfont icon-a-zu425"></span>
                  <p>优惠</p>
                </div></Col
              > -->
                    <Col span="3" class="flexCenter">
                      <img
                        v-if="item.pictureUrl"
                        :src="item.pictureUrl"
                        alt="图片缺失"
                      />
                      <img
                        v-else
                        src="@/assets/images/shoppingCart/2.png"
                        alt="图片缺失"
                      />
                    </Col>
                    <Col span="6" class="detail" style="padding-top: 20px">
                      <div style="cursor: pointer">
                        <!-- <div class="partType">{{ item.typeName }}</div> -->
                        <div
                          class="partName"
                          @click="goDetails(item)"
                          style="max-width: 196px"
                        >
                          <span class="partType">{{ item.typeName }} </span>
                          {{ item.oeCode }}
                          {{ item.brandName }}
                          {{ item.stdNameJp }}
                          {{ item.direction }}{{ item.oilGrade }}
                        </div>
                      </div>
                      <div class="oe-p" @mouseleave="closeRelevance(index)">
                        OEM码：
                        <div v-if="item.oemCode === null">--</div>
                        <div v-else>
                          <Tooltip :content=item.oemCode placement="top" :transfer="true" :max-width="200">
                            <span class="ellipsis">{{ item.oemCode }}</span>
                          </Tooltip>
                        </div>
<!--                        <p-->
<!--                          @mouseenter="getRelevance(item.partId, index, item)"-->
<!--                          v-if="item.oemCodes.length"-->
<!--                        >-->
<!--                          {{ item.oemCodes[0]-->
<!--                          }}<i-->
<!--                            class="ivu-icon ivu-icon-ios-arrow-down"-->
<!--                            v-if="item.oemCodes.length > 1"-->
<!--                          ></i>-->
<!--                        </p>-->
<!--                        <div-->
<!--                          class="relevance"-->
<!--                          :tabIndex="1"-->
<!--                          v-if="item.oemCodes.length > 1"-->
<!--                        >-->
<!--                          <div-->
<!--                            class="relevanceBox"-->
<!--                            :class="item.isShow ? 'show' : ''"-->
<!--                          >-->
<!--                            &lt;!&ndash; 关联原厂件号： &ndash;&gt;-->
<!--                            <p v-for="i in item.oemCodes.slice(1)" :key="i">-->
<!--                              {{ i }}-->
<!--                            </p>-->
<!--                          </div>-->
<!--                        </div>-->
                      </div>
                      <ul
                        style="display= flex;flex-flow: wrap;padding-left: 4px"
                      >
                        <li>服务：</li>
                        <li v-if="item.genuineGuarantee">
                          <span class="iconfont icon-a-lujing153"></span>
                          <!-- <p>正品保证</p> -->
                        </li>
                        <li v-if="item.technicalSupport">
                          <!-- <li> -->
                          <span class="iconfont icon-a-ziyuan4"></span>
                          <!-- <p>技术支持</p> -->
                        </li>
                        <li v-if="item.warrantyService">
                          <!-- <li> -->
                          <span class="iconfont icon-a-ziyuan5"></span>
                          <!-- <p>保修服务</p> -->
                        </li>
                        <!-- <li> -->
                        <li v-if="item.returnPromise">
                          <!-- <li style="margin-top: 10px"> -->
                          <span class="iconfont icon-a-ziyuan21"></span>
                          <!-- <p>退换货承诺</p> -->
                        </li>
                      </ul>
                    </Col>

                    <!-- <Col span="3" class="flexCenter">
                <div class="shop">
                  <p @click="goShop(item)" style="cursor: pointer">
                    {{ item.shopName }}
                  </p>
                  <span>{{ item.provinceName }}{{ item.cityName }}</span>
                </div>
              </Col> -->
                    <!-- 发货地 -->
                    <Col span="3" class="w120">
                      <div class="oe-p" @mouseleave="closeCity(index)">
                        <p
                          class="w122"
                          @mouseenter="getCity(item.partId, index, item)"
                          v-if="item.shipCityStores.length"
                        >
                          {{ item.shipCityStore.city }}
                          {{ item.shipCityStore.name }}
                          <i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.shipCityStores.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.shipCityStores.length > 1"
                        >
                          <div
                            class="relevanceBox w33"
                            :class="item.isShows ? 'show' : ''"
                          >
                            <p
                              v-for="i in item.shipCityStores"
                              :key="i.storeId"
                              class="w22"
                              :class="isCity === i.name ? 'isCityed' : ''"
                              @click="checkCITY(i, item)"
                            >
                              {{ i.city }}
                              {{ i.name }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col span="2" class="flexCenter"
                      >{{ item.stock &lt; 10 ? item.stock : '10+' }}/{{
                        item.unitId
                      }}</Col
                    >
                    <Col span="3"
                      ><div class="price" style="">
                        <div v-if="!item.inquiry">
                          <!-- <div> -->
                          <p>￥{{ item.price }}</p>
                          <span
                            v-if="item.type == 1"
                            class="iconfont icon-a-lujing156"
                          ></span>
                          <span v-if="item.type == 1">{{
                            item.activityTime
                          }}</span>
                        </div>
                        <p v-else>询价</p>
                      </div>
                    </Col>
                    <Col span="4">
                      <div class="number">
                        <div class="number-in">
                          <Button
                            style="border-right: 1px solid #dcdee2"
                            class="number-sub"
                            @click="cliSub(item, index)"
                            :disabled="item.Sub"
                            >-</Button
                          >
                          <input
                            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                            :id="index"
                            @blur="BlurNumber(item, index)"
                            v-model="item.maxNum"
                            style="
                              width: 53px;
                              text-align: center;
                              line-height: 31px;
                            "
                          />
                          <Button
                            class="number-add"
                            @click="cliAdd(item, index)"
                            :disabled="item.Add"
                            >+</Button
                          >
                        </div>
                        <div
                          class="number-sp"
                          :class="item.isNumber ? 'show' : ''"
                        >
                          库存不足
                        </div>
                      </div>
                    </Col>
                    <Col span="3">
                      <div class="handle" v-if="tenantId !== item.tenantId">
                        <div class="left">
                          <!-- <span
                  v-if="item.isCollect == true"
                  class="iconfont icon-shoucang"
                  title="收藏"
                  @click="getCollect(item, index, false)"
                ></span>

                <span
                  v-else
                  class="iconfont icon-a-lujing157"
                  title="收藏"
                  @click="getCollect(item, index, true)"
                ></span> -->
                          <span
                            style="padding-top: 4px"
                            class="iconfont"
                            :class="
                              item.attention
                                ? 'icon-a-ziyuan1'
                                : 'icon-a-lujing157'
                            "
                            @click="collect(item)"
                          ></span>
                          <div v-if="!item.inquiry" class="regular">
                            <span
                              class="iconfont icon-a-zu420"
                              title="加入购物车"
                              @click="setShopCat(item, index)"
                            ></span>
                          </div>
                          <div v-else class="noregular">
                            <span class="iconfont icon-a-zu420"></span>
                          </div>
                          <!-- <span
                  v-else
                  class="iconfont icon-a-lujing205"
                  title="加入询价单"
                ></span> -->
                          <!-- <span
                    @click="go('im')"
                    c
                    title="联系客服"
                  ></span> -->
                          <xiaopei
                            style="padding-top: 4px"
                            :oppositeTenantId="item.tenantId"
                            :partId="item.partId"
                            ><i class="iconfont icon-a-lujing162"></i
                          ></xiaopei>
                          <!-- icon-a-ziyuan1  icon-a-lujing157 -->
                        </div>
                        <div
                          class="right"
                          v-if="item.inquiry == 0"
                          style="marhin-right: 0"
                        >
                          <Button
                            @click="prebuy(item)"
                            type="error"
                            :loading="item.buyLoading"
                            >立即购买</Button
                          >
                        </div>
                        <div class="right" v-if="item.inquiry == 1">
                          <Button @click="enquiry(item)" type="primary"
                            >立即询价</Button
                          >
                        </div>
                      </div></Col
                    >
                  </Row>
                </div>
              </transition-group>
              <!-- 数据为空 -->
              <div class="emptyData" v-if="dataList.length == 0">
                <p>
                  <span
                    ><i
                      ><Icon
                        type="ios-alert-outline"
                        size="17"
                      />没找到您想要的数据~</i
                    ></span
                  >
                </p>
              </div>
              <!-- 加载中 -->
              <div class="demo-spin-container" v-if="spinShow">
                <Spin fix></Spin>
              </div>
            </div>
            <div
              style="display: flex; justify-content: right; margin-top: 10px"
            >
              <Page
                :total="pager.total"
                :current="pager.current"
                :page-size="pager.size"
                size="small"
                :page-size-opts="[30]"
                show-total
                @on-change="changeCurrent"
                @on-page-size-change="changeSize"
              />
              <span
                style="
                  line-height: 11px;
                  height: 26px;
                  padding: 7px 10px;
                  border: 1px solid #dcdee2;
                  border-radius: 3px;
                "
                >30条/页</span
              >
            </div>
          </div>
        </div>
        <!-- <JPremitL ref="JPremitL" @checked="checked"></JPremitL> -->
        <!-- <JPremitR ref="JPremitR" @getCheckids="getCheckids"></JPremitR> -->
      </div>
    </div>
    <!-- 选择车型弹框-->
    <Modal
      v-model="carType1"
      :mask-closable="false"
      :closable="false"
      footer-hide
      width="750"
    >
      <p slot="header">
        <span>请选择品牌</span>
        <Icon
          type="md-close-circle"
          size="24"
          color="#BBBBBB"
          @click="carType1 = false"
        />
      </p>
      <carModal @closeMOdal="closeMOdal" ref="carTypes1"></carModal>
    </Modal>
    <Modal
      v-model="carType2"
      :mask-closable="false"
      :closable="false"
      footer-hide
      width="750"
    >
      <p slot="header">
        <span>请选择品牌</span>
        <Icon
          type="md-close-circle"
          size="24"
          color="#BBBBBB"
          @click="carType2 = false"
        />
      </p>

      <caseIndex @closeMOdal="closeMOdal" ref="carTypes2"></caseIndex>
    </Modal>

    <!-- 查询 搜配数据/佳配数据 -->
    <Modal
      v-model="otherModel"
      :mask-closable="false"
      :closable="false"
      footer-hide
      width="750"
    >
      <p slot="header">
        <span>请选择产品车型库</span>
        <Icon
          type="md-close-circle"
          size="24"
          color="#BBBBBB"
          @click="otherModel = false"
        />
      </p>
      <div class="modal-content">
        <div class="variableDom">
          <img src="./变速箱.jpg" alt="" />
          <p>变速器</p>
          <p>滤清器</p>
        </div>
        <Button
          type="primary"
          style="width: 100px; height: 32px"
          size="small"
          class="variableBtn"
          @click="openCar(1)"
          >请选择车型</Button
        >
        <Button
          type="primary"
          style="width: 100px; height: 32px"
          size="small"
          class="otherBtn"
          @click="openCar(2)"
          >请选择车型</Button
        >
        <div class="centerDom"></div>
        <div class="otherDom">
          <img src="./易损件.jpg" alt="" />
          <p>其他</p>
          <p>易损件</p>
        </div>
      </div>
    </Modal>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <Slider></Slider>
    <Footer></Footer>
    <FooterP></FooterP>
  </div>
</template>

<script>
import HeaderTop from '../base/common/header-top.vue'
import Slider from '../base/common/slider.vue'
// import JPremitL from './components/JPremitL.vue'
// import JPremitR from './components/JPremitR.vue'
import Footer from '../base/common/footer.vue'
import FooterP from '@/views/base/common/footer-p.vue'
import carModal from './carComponents/index.vue'
import caseIndex from './carComponents/caseIndex.vue'

import enquirytk from '../base/common/enquirytk.vue'
import { JPremit } from './JPremit'
import { getDictList, findModelByType } from '@/api/JPremit.js'
import xiaopei from '@/views/xiaopei/index.vue'
import { getListAddress } from '@/api/goodsList.js'
export default {
  components: {
    HeaderTop,
    Footer,
    Slider,
    // JPremitL,
    // JPremitR,
    FooterP,
    carModal,
    caseIndex,
    xiaopei,
    enquirytk
  },
  mixins: [JPremit],
  data() {
    return {
      isChanges: '',
      isChange: '',
      enquirydata: {}, // 询价数据
      carType1: false, // 车型弹框
      carType2: false, // 车型弹框
      obj: {
        partKey: '',
        VinKey: ''
      },
      checkli: 1,
      check: 1, // 当前是哪种搜索方式
      searchList: {
        partKey: '',
        VinKey: '',
        brandName: '',
        carName: '',
        carType: ''
      },
      modelVO: {}, //当时车型选择这个回显数据
      copyARR: [],
      arr: [], // 选中数组
      thirdTree: [], // 所有标准名称
      tree: [], //左边标准名称展示
      jpremitShpw: false, // 车型结果展示
      show: false,
      spinShow: true,
      SEvalue: '', // vin/车型查询里面的OE查询
      addressId: '', // 发货地
      dataList: [], // 配件列表数据为空呢显示加载
      partCheck: '-1', // 选中配件类型
      brandCheck: '不限', // 选中品牌
      parTypeList: [], // 配件类型
      brandList: [], // 品牌
      hasGoods: '', //是否有货
      checkNum: 0, // 0/销量 1/库存 2/价格
      inventoryNum: 0, //库存点击次数
      priceNum: 0, //价格点击次数
      searchData: {
        nameStr: '', //左侧标准名称集合
        searchType: '1', // 判断是哪个类型查询
        keyword: '', // 配件查询(编码或名称)
        vinCode: '', // vin查询
        carBrandName: '', //车型搜索（品牌名称）
        modeId: '', //车型搜索（车型id）
        epc: '', //车型搜索（车集团）
        partType: '', // 配件类型id
        brandId: '', // 品牌id
        inStock: '', // 是否有货
        shipCityId: '', // 发货地
        // leagueId: '',
        area: 1, // 专区(交易1/自营2/股东3/店铺4)
        stockSort: '', // 库存查询排序(1升序，2降序)
        priceSort: '', // 价格查询排序,(1升序，2降序)
        current: 1,
        size: 30
      },
      carResult: {}, // 车型/vin查询结果
      // 分页
      pager: {
        current: 1,
        total: 0,
        size: 30
      },
      // i: '', // 上头选中哪个输入框
      // val: {}, // 上头输入框的数据
      isClear: false,
      treeList: [], //
      treeIds: [],
      otherModel: false,
      isOther: false //搜配查询
    }
  },
  created() {
    this.getDictList()
    this.getListAddress()
    this.getDataList()
  },
  methods: {
    openCar(type) {
      this.isOther = type == 1 ? true : false
      this.otherModel = false
      type == 1
        ? (this.$refs.carTypes2.getlistAllLabel(), (this.carType2 = true))
        : (this.$refs.carTypes1.getlistAllLabel(), (this.carType1 = true))
    },
    // 获取左侧标准名称
    async getDictList() {
      const res = await getDictList()
      console.log(res)
      if (res.status) {
        this.tree = res.data.tree
        this.tree.forEach(item => {
          item.children.forEach(i => {
            if (i.partNameList == null || i.partNameList == []) {
            } else {
            }
          })
        })
        this.thirdTree = res.data.thirdTree
        this.treeList = res.data.tree
      }
    },
    // 获取发货地
    async getListAddress() {
      let res = await getListAddress()
      this.cityList = res.data
      this.cityList.unshift({ id: '-1', name: '全国' })
      this.addressId = '-1'
      this.searchData.shipCityId = this.addressId
    },
    // 获取配件列表
    async getDataList() {
      this.show = true
      this.spinShow = true
      this.pager.total = 0 //总条数

      let data = JSON.parse(JSON.stringify(this.searchData))
      data.partType = data.partType == '-1' ? '' : data.partType //配件类型
      data.brandId = data.brandId == '-1' ? '' : data.brandId //配件品牌
      data.inStock = this.hasGoods ? 1 : '' // 是否有货
      data.shipCityId = data.shipCityId == '-1' ? '' : data.shipCityId // 发货地
      if (!this.isClear) {
        if (this.arr.length > 0) {
          data.nameStr = data.nameStr.join(',')
        } else {
          data.nameStr = ''
        }
      }
      let res = await findModelByType(data)
      console.log(res)
      res.num = 0
      if (res.status) {
        this.$nextTick(() => {
          // debugger
          if (res.data.ipage == null) {
            this.dataList = []
          } else {
            this.dataList = res.data.ipage.records // 配件类表
            this.pager.total = res.data.ipage.total //总条数
          }
          if (res.data.partBrandVOList == null) {
            this.brandList = []
          } else {
            this.brandList = res.data.partBrandVOList
            this.brandList.unshift('不限')
          }
          if (res.data.partsTypeList == null) {
            this.parTypeList = []
            this.parTypeList.unshift({ id: '-1', name: '不限' })
          } else {
            this.parTypeList = res.data.partsTypeList
            this.parTypeList.unshift({ id: '-1', name: '不限' })
          }
          if (this.check == 2) {
            this.carResult = this.modelVO
          } else {
            if (res.data.modelVO !== null) {
              this.carResult = res.data.modelVO
            }
          }
          // 当他是配件搜索回显标准名称
          if (
            (this.check == 1 || this.check == 2 || this.check == 3) &&
            this.isClear
          ) {
            this.copyARR = res.data.partsStdNameList
            this.treeIds = res.data.partTypeAggNum
            // this.treeIds[0].val = 8
            // console.log(this.treeIds)
            this.ischecked()
          }
          this.getMaxNum()
        })
      } else {
        this.dataList = []
      }
      this.spinShow = false
    },
    // 车型/vin查询(配件编码/配件名称)
    searchBtn() {
      this.searchData.keyword = this.SEvalue
      this.isClear = true
      this.searchData.nameStr = ''
      this.arr = []
      // this.val.oeCode = this.value
      this.getDataList()
    },
    // 选择三种搜索方式其一
    chicoe(i) {
      if (this.check == 2 && i == 1) {
        location.reload()
      } else if (this.check == 3 && i == 1) {
        location.reload()
      }
      console.log(i)
      this.obj = {
        partKey: '',
        VinKey: ''
      }
      this.searchList = {
        partKey: '',
        VinKey: '',
        brandName: '',
        carName: '',
        carType: ''
      }
      this.check = i
    },
    // 上方三选一输入框搜索(样式切换)
    Search(val) {
      this.searchData.searchType = val
      if (val == 1) {
        // 配件查询
        if (this.obj.partKey) {
          console.log('111')
          this.isClear = true
        } else {
          console.log('2222')
          this.isClear = false
        }
        this.jpremitShpw = false
        this.searchData.keyword = this.obj.partKey
        this.searchList.partKey = this.obj.partKey

        this.clearList()
        // this.searchData.nameStr = ''
        this.getListAddress()
        this.getDataList()
        this.checkli = val
      } else if (val == 2) {
        // 车型查询
        this.jpremitShpw = true
        // this.$refs.carTypes.getlistAllLabel()
        this.otherModel = true
        this.searchData.keyword = this.SEvalue
      } else {
        this.SEvalue = ''
        this.searchData.keyword = this.SEvalue
        this.addressId = '-1'
        this.searchData.shipCityId = this.addressId
        this.searchData.current = 1
        this.searchData.size = 30
        this.checkLength(this.obj.VinKey)
      }
    },
    // 检测字符串长度
    checkLength(val) {
      const key = JSON.parse(JSON.stringify(val))
      const list = key.replace(/[, ]/g, '')
      let len = 0
      for (let i = 0; i < list.length; i++) {
        if (list.charCodeAt(i) > 127 || list.charCodeAt(i) == 94) {
          len += 2
        } else {
          len++
        }
      }
      if (len == 17) {
        // Vin查询
        this.jpremitShpw = true
        this.searchData.vinCode = this.obj.VinKey
        this.searchList.VinKey = this.obj.VinKey
        this.clearList()
        this.getListAddress()
        this.getDataList()
        this.checkli = 3
      } else {
        this.$Message.destroy()
        this.$Message.warning('请输入17位车架号')
      }
    },
    // 搜索不同的配件方式，筛选条件都要清空
    clearList() {
      this.SEvalue = ''
      this.searchData.partType = ''
      this.searchData.brandId = ''
      this.searchData.inStock = ''
      this.searchData.shipCityId = ''
      this.searchData.stockSort = ''
      this.searchData.priceSort = ''
      this.searchData.current = 1
      this.searchData.size = 30
      this.searchData.nameStr = ''
      this.brandCheck = '-1'
      this.partCheck = '-1'
      this.arr = []
      this.checkNum = 0 // 0/销量 1/库存 2/价格
      this.inventoryNum = 0 //库存点击次数
      this.priceNum = 0 //价格点击次数
    },
    // 获取商品列表标准名称数据的回显
    getCheckids(ids) {
      this.$refs.JPremitL.checkids(ids)
    },
    // 关闭选择车型弹框
    closeMOdal(val) {
      console.log(val, '车型查询一号')

      if (this.isOther) {
        this.modelVO.brand = val.cmBrand
        this.modelVO.series = val.series
        this.modelVO.model = val.cmModel
        this.modelVO.model_year = val.cmModelYear
        this.modelVO.cc = val.cmDisplacement
        this.modelVO.trans_code = val.trans_code
        this.modelVO.engine_no = val.engine_no
        this.searchList.brandName = val.cmBrand
        this.searchList.carName =
          val.cmFactory + ' ' + val.cmModelYear + ' ' + val.cmDisplacement + ' '
        this.searchList.carType = val.cmModel

        this.searchData.soPei = {
          cmBrand: val.cmBrand,
          cmFactory: val.cmFactory,
          cmModel: val.cmModel,
          cmDisplacement: val.cmDisplacement,
          cmModelYear: val.cmModelYear
        }
        // this.searchData.soPei.cmFactory = val.cmFactory
        // this.searchData.soPei.cmModel = val.cmModel
        // this.searchData.soPei.cmDisplacement = val.cmDisplacement
        // this.searchData.soPei.cmModelYear = val.cmModelYear
      } else {
        this.modelVO.brand = val.brand
        this.modelVO.series = val.series
        this.modelVO.model = val.model
        this.modelVO.model_year = val.model_year
        this.modelVO.cc = val.cc
        this.modelVO.trans_code = val.trans_code
        this.modelVO.engine_no = val.engine_no
        this.searchList.brandName = val.brandName
        this.searchList.carName = val.carName
        this.searchList.carType = val.carType
        this.searchData.carBrandName = val.brandName
        this.searchData.modeId = val.id
        this.searchData.epc = val.epc
        delete this.searchData.soPei
      }
      this.carType1 = false
      this.carType2 = false

      this.clearList()
      this.getListAddress()
      this.getDataList()
      this.checkli = 2
    },
    // 删除车型选择
    delcarType() {
      this.searchList.brandName = ''
      this.searchList.carName = ''
      this.searchList.carType = ''
    },
    // 配件搜索回显标准名称
    ischecked() {
      this.thirdTree.forEach(item => {
        this.copyARR.forEach(i => {
          if (i == item) {
            this.arr.push(i)
          }
        })
      })
      // this.treeList.forEach((item) => {
      //   this.treeIds.forEach((val) => {
      //     if (item.id == val.id) {
      //       item.num = val.val
      //     }
      //     if (item.children) {
      //       item.children.forEach((i) => {
      //         if (i.id == val.id) {
      //           i.num = val.val
      //         }
      //       })
      //     }
      //   })
      // })
      // this.tree = this.treeList
    },
    // 多个选中
    checkeds(label) {
      if (this.arr.indexOf(label) !== -1) {
        // 找到了
        this.arr.splice(this.arr.indexOf(label), 1)
      } else {
        // 未找到
        this.arr.push(label)
      }
      console.log(this.arr)
      this.obj.partKey = ''
      // this.searchList = {
      //   partKey: '',
      //   // VinKey: '',
      //   // brandName: '',
      //   // carName: '',
      //   // carType: ''
      // }
      this.searchList.partKey = ''
      this.searchData.keyword = ''
      this.SEvalue = ''
      this.searchData.nameStr = this.arr
      this.isClear = false
      this.getDataList()
    },
    // 数据回显多个选中
    checkids(ids) {
      this.arr = []
      ids.forEach(item => {
        if (this.arr.indexOf(item) !== -1) {
          // 找到了
          this.arr.splice(this.arr.indexOf(item), 1)
        } else {
          // 未找到
          this.arr.push(item)
        }
      })
      // console.log(this.arr);
    },
    clickOne(item, index) {
      console.log(item, index)
      if (item.isShow) {
        this.$set(this.tree[index], 'isShow', false)
      } else {
        this.$set(this.tree[index], 'isShow', true)
      }

      // if (val == this.isChange) {
      //   this.isChange = ''
      // } else {
      //   this.isChange = val
      // }
    },
    clickTwo(i, index) {
      console.log(i)
      if (i.isShow) {
        this.$set(i, 'isShow', false)
      } else {
        this.$set(i, 'isShow', true)
      }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
@import './JPremitR.less';
@import './index.less';

.ellipsis {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px; /* 根据需要调整最大宽度 */
}
</style>
